var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "collection" }, [
      _c("div", [
        _c("img", {
          staticStyle: { width: "40px", height: "40px" },
          attrs: { src: require("@/assets/appNew/Collect.png"), alt: "" },
        }),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          staticStyle: { width: "40px", height: "40px" },
          attrs: { src: require("@/assets/appNew/Footprints.png"), alt: "" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }